import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#63B680" d="M5 15.008h2.627v3.483H5z"/> <path fill="#63B680" fill-rule="evenodd" d="M11.419 11.842H9.124v6.65h2.627v-6.318l-.332-.332z" clip-rule="evenodd"/> <path fill="#63B680" d="M13.249 8.675h2.627v9.817h-2.627V8.675z"/> <path fill="#CECECE" d="M17.373 5.508H20v12.984h-2.627V5.508z"/>' }
  })
);